import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MinistryStatus } from '@core/api/generated/api-client';
import { ministryStatusLabels } from '@core/api/enums/ministry-status.labels';

@Component({
  selector: 'app-ministry-status-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './ministry-status-badge.component.html',
  styleUrl: './ministry-status-badge.component.scss'
})
export class MinistryStatusBadgeComponent {
  @Input() status?: MinistryStatus | null;

  get label(): string | null {
    if (!this.status) return null;
    return ministryStatusLabels[this.status] ?? this.status;
  }
}
